/* Black Design Days Opt-in: Klaviyo-Anmeldung, Countdown, Scroll-CTA, Rubbelkarte.
   Wird von jeder bdd-Section geladen; init() läuft pro Element nur einmal. */
(function () {
  if (window.bddOptin) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Formular ---------- */
  function subscribe(root, email) {
    var list = root.dataset.list;
    var company = root.dataset.company;
    if (!list || !company) return Promise.reject(new Error('config'));
    var source = root.dataset.source || 'Black Design Days Opt-in';
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: email, properties: { bdd_optin_source: source } } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('http ' + res.status);
    });
  }

  function track(email, source) {
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
    try { if (window.fbq) window.fbq('track', 'Lead', { content_name: source }); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'bdd_optin', bdd_source: source }); } catch (e) {}
  }

  function initForm(root) {
    if (!once(root, 'bddInit')) return;
    var form = root.querySelector('form');
    var input = root.querySelector('input[type="email"]');
    var hp = root.querySelector('.bdd-form__hp');
    var btn = root.querySelector('button[type="submit"]');
    var err = root.querySelector('[data-bdd-error]');
    var success = root.querySelector('[data-bdd-success]');

    function showError(msg) {
      err.textContent = msg;
      err.hidden = false;
    }

    function done(email) {
      root.classList.add('is-done');
      if (success) success.hidden = false;
      track(email, root.dataset.source || '');
      root.dispatchEvent(new CustomEvent('bdd:subscribed', { bubbles: true, detail: { email: email } }));
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true;
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showError('Bitte gib eine gültige E-Mail-Adresse ein.');
        input.focus();
        return;
      }
      if (hp && hp.value) { done(email); return; }
      btn.disabled = true;
      subscribe(root, email).then(function () {
        done(email);
      }).catch(function (e2) {
        btn.disabled = false;
        showError(e2 && e2.message === 'config'
          ? 'Die Anmeldung ist gerade nicht eingerichtet. Bitte versuch es später noch einmal.'
          : 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.');
      });
    });
  }

  /* ---------- Eingebettete Klaviyo-Formulare ----------
     Klaviyo meldet Absenden über das window-Event "klaviyoForms" (detail.type === 'submit').
     Alle Wrapper mit dieser Formular-ID wechseln in den Erfolgszustand. */
  function initKlaviyoEvents() {
    if (window.bddKlaviyoBound) return;
    window.bddKlaviyoBound = true;
    window.addEventListener('klaviyoForms', function (e) {
      var d = e.detail || {};
      if (d.type !== 'submit' || !d.formId) return;
      var email = (d.metaData && (d.metaData.$email || d.metaData.email)) || '';
      var matched = false;
      document.querySelectorAll('[data-bdd-kform]').forEach(function (root) {
        if ((',' + root.dataset.forms + ',').indexOf(',' + d.formId + ',') === -1) return;
        matched = true;
        if (root.classList.contains('is-done')) return;
        root.classList.add('is-done');
        var success = root.querySelector('[data-bdd-success]');
        if (success) success.hidden = false;
        root.dispatchEvent(new CustomEvent('bdd:subscribed', { bubbles: true, detail: { email: email, formId: d.formId } }));
      });
      /* Meta-Lead: Der Pixel läuft nicht im Theme, sondern als Custom Pixel in den Shopify-Kundenereignissen.
         Der Pixel abonniert dieses Event (nur echte Absendungen der BDD-Formulare). */
      try {
        if (matched && window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('bdd_optin_lead', { formId: d.formId, page: location.pathname });
        }
      } catch (err) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'bdd_optin', bdd_form: d.formId }); } catch (err) {}
    });
  }

  /* ---------- Countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown(el) {
    if (!once(el, 'bddInit')) return;
    var target = new Date(el.dataset.target).getTime();
    if (isNaN(target)) return;
    var d = el.querySelector('[data-cd-d]'), h = el.querySelector('[data-cd-h]'),
        m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    var timer;
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        var units = el.querySelector('.bdd-cd__units');
        if (units) units.remove();
        var label = el.querySelector('.bdd-cd__label');
        if (label && el.dataset.expired) label.textContent = el.dataset.expired;
        return;
      }
      d.textContent = pad(Math.floor(diff / 86400000));
      h.textContent = pad(Math.floor(diff % 86400000 / 3600000));
      m.textContent = pad(Math.floor(diff % 3600000 / 60000));
      s.textContent = pad(Math.floor(diff % 60000 / 1000));
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- Scroll zum Formular ---------- */
  function initScrollCta(el) {
    if (!once(el, 'bddInit')) return;
    el.addEventListener('click', function (e) {
      var inputs = Array.prototype.filter.call(document.querySelectorAll('.bdd-form:not(.is-done) input[type="email"]'), function (i) { return i.offsetParent !== null; });
      if (!inputs.length) return;
      var from = el.getBoundingClientRect().top;
      var input = Array.prototype.reduce.call(inputs, function (best, cur) {
        return Math.abs(cur.getBoundingClientRect().top - from) < Math.abs(best.getBoundingClientRect().top - from) ? cur : best;
      });
      e.preventDefault();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
    });
  }

  /* ---------- Rubbelkarte ---------- */
  function initScratch(root) {
    if (!once(root, 'bddInit')) return;
    var card = root.querySelector('[data-bdd-card]');
    var cover = root.querySelector('[data-bdd-cover]');
    var revealBtn = root.querySelector('[data-bdd-reveal]');
    if (!card || !cover) return;

    // Das Deckblatt wird direkt in eine Canvas gemalt und dort freiradiert.
    // (Früher per CSS-Maske: Safari blendet das Element aus, während es jede neue Maske lädt.)
    var canvas = document.createElement('canvas');
    canvas.className = 'bdd-card__canvas';
    canvas.setAttribute('aria-hidden', 'true');
    var ctx = canvas.getContext && canvas.getContext('2d', { willReadFrequently: true });
    var scale = 1, drawing = false, last = null, revealed = false, pendingScroll = false, strokes = 0;
    var path = [];            // Radier-Striche in relativen Koordinaten, für Neuzeichnen nach Resize
    var handImg = null;

    var rowsEl = cover.querySelector('.bdd-card__cover-rows');
    var ctaEl = cover.querySelector('.bdd-card__cover-cta');
    var handSrc = ctaEl && ctaEl.querySelector('img') ? ctaEl.querySelector('img').src : '';
    if (handSrc) { handImg = new Image(); handImg.onload = function () { if (!revealed) draw(); }; handImg.src = handSrc; }

    function fontFamily() {
      var el = rowsEl && rowsEl.querySelector('span');
      return el ? getComputedStyle(el).fontFamily : 'sans-serif';
    }

    function paintCover(w, h) {
      // Verlauf wie im Figma: 140.7deg
      var a = 140.7 * Math.PI / 180, dx = Math.sin(a), dy = -Math.cos(a);
      var len = Math.abs(w * dx) + Math.abs(h * dy);
      var g = ctx.createLinearGradient(w / 2 - dx * len / 2, h / 2 - dy * len / 2, w / 2 + dx * len / 2, h / 2 + dy * len / 2);
      [[0, '#8c8c8c'], [0.214, '#e9e9e9'], [0.393, '#a3a3a3'], [0.571, '#dcdcdc'], [0.714, '#9a9a9a'], [1, '#9a9a9a']].forEach(function (st) { g.addColorStop(st[0], st[1]); });
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      var fam = fontFamily();
      // Muster-Zeilen (Positionen aus dem Figma, relativ zur Kartenbreite)
      var rows = rowsEl ? rowsEl.querySelectorAll('span') : [];
      ctx.fillStyle = 'rgba(0,0,0,0.07)';
      ctx.font = '700 ' + (w * 0.0682) + 'px ' + fam;
      ctx.textBaseline = 'top';
      var tops = [-0.0136, 0.0955, 0.2045, 0.3136, 0.4227, 0.5318];
      for (var i = 0; i < rows.length && i < tops.length; i++) {
        ctx.fillText(rows[i].textContent.toUpperCase(), (i % 2 ? -0.227 : -0.0455) * w, tops[i] * w);
      }
      // Hand-Icon und „Hier freirubbeln“ mittig
      if (ctaEl) {
        var label = (ctaEl.querySelector('span') || {}).textContent || '';
        label = label.toUpperCase();
        var fs = w * 0.0864, icon = w * 0.0818, gap = w * 0.027;
        ctx.font = '700 ' + fs + 'px ' + fam;
        var tw = ctx.measureText(label).width;
        var x = (w - (icon + gap + tw)) / 2, cy = h / 2;
        if (handImg && handImg.complete && handImg.naturalWidth) ctx.drawImage(handImg, x, cy - icon / 2, icon, icon);
        ctx.fillStyle = '#202223';
        ctx.textBaseline = 'middle';
        ctx.fillText(label, x + icon + gap, cy + fs * 0.04);
      }
    }

    function stroke(a, b) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = Math.max(canvas.width * 0.11, 18 * scale);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(a.x * canvas.width, a.y * canvas.height);
      ctx.lineTo(b.x * canvas.width, b.y * canvas.height);
      ctx.stroke();
    }

    function draw() {
      var r = cover.getBoundingClientRect();
      if (!r.width || !ctx) return;
      scale = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(r.width * scale);
      canvas.height = Math.round(r.height * scale);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      paintCover(canvas.width, canvas.height);
      for (var i = 0; i < path.length; i++) stroke(path[i][0], path[i][1]);
      cover.classList.add('is-canvas');
    }

    function point(e) {
      var r = cover.getBoundingClientRect();
      return { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height };
    }

    function scratchLine(a, b) {
      path.push([a, b]);
      stroke(a, b);
    }

    function clearedRatio() {
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var clear = 0, total = 0;
      for (var i = 3; i < data.length; i += 64) { total++; if (data[i] < 128) clear++; }
      return total ? clear / total : 0;
    }

    // Mobil: nach dem Freirubbeln so scrollen, dass Feld und Button sichtbar sind,
    // ohne die Glückwunsch-Überschrift oben abzuschneiden.
    function scrollToForm() {
      var after = root.querySelector('.bdd-scratch__after');
      var head = root.querySelector('.bdd-scratch__congrats');
      if (!after || !head) return;
      var btns = Array.prototype.filter.call(after.querySelectorAll('button, input[type="submit"]'), function (b) { return b.offsetParent !== null; });
      var formBottom = btns.length ? btns[btns.length - 1].getBoundingClientRect().bottom : after.getBoundingClientRect().bottom;
      var delta = formBottom - (window.innerHeight - 24);
      var maxDelta = head.getBoundingClientRect().top - 72;
      delta = Math.min(delta, maxDelta);
      if (delta > 0) window.scrollBy({ top: delta, behavior: 'smooth' });
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      card.classList.add('is-scratched');
      setTimeout(function () {
        root.classList.add('is-revealed');
        var input = root.querySelector('.bdd-scratch__after input[type="email"]');
        if (input && window.matchMedia('(min-width: 769px)').matches) input.focus({ preventScroll: true });
        else if (drawing) pendingScroll = true;
        else setTimeout(scrollToForm, 420);
      }, 380);
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'bdd_scratch_revealed' }); } catch (e) {}
    }

    cover.addEventListener('pointerdown', function (e) {
      if (revealed) return;
      if (!ctx) { reveal(); return; }
      e.preventDefault();
      drawing = true;
      last = point(e);
      scratchLine(last, { x: last.x + 0.001, y: last.y + 0.001 });
      try { cover.setPointerCapture(e.pointerId); } catch (err) {}
    });
    cover.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    cover.addEventListener('pointermove', function (e) {
      if (!drawing || revealed) return;
      var p = point(e);
      scratchLine(last, p);
      last = p;
      if (++strokes % 12 === 0 && clearedRatio() > 0.45) reveal();
    });
    function stop() {
      if (!drawing) return;
      drawing = false;
      if (pendingScroll) { pendingScroll = false; setTimeout(scrollToForm, 150); return; }
      if (!revealed && clearedRatio() > 0.45) reveal();
    }
    cover.addEventListener('pointerup', stop);
    cover.addEventListener('pointercancel', stop);
    window.addEventListener('pointerup', stop);
    window.addEventListener('pointercancel', stop);
    window.addEventListener('touchend', stop);
    cover.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); reveal(); }
    });
    if (revealBtn) revealBtn.addEventListener('click', reveal);

    root.addEventListener('bdd:subscribed', function () {
      root.classList.add('is-done');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (ctx) {
      cover.insertBefore(canvas, cover.firstChild);
      draw();
      if (window.ResizeObserver) new ResizeObserver(function () { if (!revealed) draw(); }).observe(cover);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!revealed) draw(); });
    }
  }

  function init(scope) {
    scope = scope || document;
    initKlaviyoEvents();
    scope.querySelectorAll('[data-bdd-form]').forEach(initForm);
    scope.querySelectorAll('[data-bdd-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-bdd-scroll-form]').forEach(initScrollCta);
    scope.querySelectorAll('[data-bdd-scratch]').forEach(initScratch);
  }

  window.bddOptin = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
